import { useMemo } from 'react'
import { ConversationSession } from '../utils/conversationStorage'

export const getMessageLimit = (isPremium: boolean): number => {
  return isPremium ? 10 : 4
}

export const useMessageLimits = (
  session: ConversationSession | null,
  isPremium: boolean
) => {
  const limit = useMemo(() => getMessageLimit(isPremium), [isPremium])

  const currentCount = useMemo(() => {
    return session?.messageCount || 0
  }, [session])

  const canSendMessage = useMemo(() => {
    if (!session) return true
    return currentCount < limit
  }, [session, currentCount, limit])

  const remainingMessages = useMemo(() => {
    return Math.max(0, limit - currentCount)
  }, [limit, currentCount])

  const hasReachedLimit = useMemo(() => {
    return !canSendMessage
  }, [canSendMessage])

  return {
    limit,
    currentCount,
    canSendMessage,
    remainingMessages,
    hasReachedLimit
  }
}

